import styled from "styled-components";

export const Wrapper = styled.div<{
  borderColor?: string;
}>`
  max-width: ${props => props.theme.widths.claimMax};
  background-color: ${props => props.theme.ui.colors.white};
  border-bottom: 3px solid ${props => props.borderColor || "transparent"};
`;
